var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5607 15.4397L13.7529 11.6319C14.5397 10.4461 15.0002 9.02634 15.0002 7.50008C15.0002 3.36454 11.6356 0 7.50008 0C3.36454 0 0 3.36454 0 7.50008C0 11.6356 3.36454 15.0002 7.50008 15.0002C9.02634 15.0002 10.4461 14.5397 11.6319 13.7529L15.4397 17.5607C16.0247 18.1464 16.9757 18.1464 17.5607 17.5607C18.1464 16.9749 18.1464 16.0254 17.5607 15.4397ZM2.25002 7.50008C2.25002 4.60505 4.60505 2.25002 7.50008 2.25002C10.3951 2.25002 12.7501 4.60505 12.7501 7.50008C12.7501 10.3951 10.3951 12.7501 7.50008 12.7501C4.60505 12.7501 2.25002 10.3951 2.25002 7.50008Z",
    fill: "#051D42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.fd390978abfff3c124a9df9f72197caf.svg";
export { ForwardRef as ReactComponent };